import { ButtonProps } from "@material-ui/core";

export interface AlmeScrollButtonConfig {
    scrollButton: {
        styles: {
            color: ButtonProps['color'];
            variant: ButtonProps['variant'];
        };
    };
}

/**
 * This is the baseline scroll button config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
*/
const defaultConfig: AlmeScrollButtonConfig = {
    scrollButton: {
        styles: {
            color: 'primary' as const,
            variant: 'contained' as const,
        },
    },
};

export default defaultConfig;